import React from 'react';

import Popup from '../../../common/Popup/Popup.module';

interface PreviewPopupProps {
	isOpen: boolean;
	onClose: () => void;
	fields: {
		typeDemande: '' | 'vente' | 'location';
		typeBien: string;
		dateRdv: string;
		heureRdv: string;
		civilite: string;
		nomContact: string;
		telContact: string;
		emailContact: string;
		adresseBien: string;
		notesReferent?: string;
	};
	selectedMemberName?: string;
	selectedMemberRole?: string;
	formatDateFR: (d: string) => string;
	onConfirm: () => void;
}

function PreviewPopup({ isOpen, onClose, fields, selectedMemberName, selectedMemberRole, formatDateFR, onConfirm }: PreviewPopupProps) {
	return (
		<Popup
			isOpen={isOpen}
			onClose={onClose}
			title={<div className="flex items-center gap-2"><span role="img" aria-label="eye">👁️</span> Prévisualisation du Rendez-vous</div>}
			additionalClass="w-full max-w-3xl"
		>
			<div className="space-y-4 text-sm">
				<div className="overflow-hidden rounded-xl border-2 border-slate-200">
					<div className="px-5 py-3 text-white" style={{ background: fields.typeDemande === 'vente' ? 'linear-gradient(135deg, #16a34a 0%, #22c55e 100%)' : 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)' }}>
						<div className="text-lg font-bold">
							{(fields.typeDemande === 'vente' ? <span><span role="img" aria-label="house">🏠</span> VENTE</span> : fields.typeDemande === 'location' ? <span><span role="img" aria-label="key">🔑</span> LOCATION</span> : 'RDV')} — {fields.typeBien || 'Type de bien'}
						</div>
						{fields.dateRdv && fields.heureRdv && (
							<div className="mt-2 inline-block rounded-full bg-white/20 px-3 py-1">
								{formatDateFR(fields.dateRdv)} à {fields.heureRdv}
							</div>
						)}
					</div>
					<div className="space-y-3 p-5">
						<div className="flex flex-wrap gap-3">
							<div className="min-w-[120px] font-semibold"><span role="img" aria-label="person">👤</span> Contact :</div>
							<div><strong>{fields.civilite} {fields.nomContact}</strong></div>
						</div>
						<div className="flex flex-wrap gap-3">
							<div className="min-w-[120px] font-semibold"><span role="img" aria-label="telephone">📞</span> Téléphone :</div>
							<div>{fields.telContact}</div>
						</div>
						<div className="flex flex-wrap gap-3">
							<div className="min-w-[120px] font-semibold"><span role="img" aria-label="email">📧</span> Email :</div>
							<div>{fields.emailContact}</div>
						</div>
						<div className="flex flex-wrap gap-3">
							<div className="min-w-[120px] font-semibold"><span role="img" aria-label="pin">📍</span> Adresse :</div>
							<div>{fields.adresseBien}</div>
						</div>
						{selectedMemberName && (
							<div className="flex flex-wrap gap-3">
								<div className="min-w-[120px] font-semibold"><span role="img" aria-label="people">👥</span> Assigné à :</div>
								<div><strong>{selectedMemberName}</strong> ({selectedMemberRole || ''})</div>
							</div>
						)}
						{fields.notesReferent && (
							<div className="rounded-lg border bg-slate-50 p-3">
								<div className="font-semibold"><span role="img" aria-label="memo">📝</span> Notes :</div>
								<div className="whitespace-pre-wrap">{fields.notesReferent}</div>
							</div>
						)}
					</div>
				</div>
				<div className="flex justify-end gap-2">
					<button type="button" className="rounded-lg !bg-zinc-700 px-4 py-2 text-white" onClick={onClose}>Retour</button>
					<button type="button" className="rounded-lg bg-emerald-600 px-4 py-2 text-white" onClick={onConfirm}><span role="img" aria-label="check mark">✅</span> Confirmer le RDV</button>
				</div>
			</div>
		</Popup>
	);
}

export default PreviewPopup;


